import { Component } from '@angular/core';
import { ProductSearchPage } from '@spartacus/core';
import { ViewConfig, ViewModes } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomProductListComponentService } from './custom-product-list-component.service';

@Component({
  selector: 'cx-product-list',
  templateUrl: './custom-product-list.component.html',
  standalone: false
})
export class CustomProductListComponent {
  viewMode$ = new BehaviorSubject<ViewModes>(ViewModes.Grid);
  ViewModes = ViewModes;
  model: any;

  constructor(
    private productListComponentService: CustomProductListComponentService,
    public scrollConfig: ViewConfig
  ) {}

  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;

  sortList(sortCode: string): void {
    this.productListComponentService.sort(sortCode);
  }

  setViewMode(mode: ViewModes): void {
    this.viewMode$.next(mode);
  }
}
